module.exports = __webpack_public_path__ + "img/micromall_backstage1.08776df8.png";